var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"v-dialog-crop",attrs:{"title":"剪裁图片","closable":""}},[_vm._v("\n\txxx\n\t"),_c('v-button',{on:{"click":function($event){return _vm.resolve()}}},[_vm._v("确定")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }